<template>
    <div>
        <div v-if="showValue" class="plain-argument">
            <div class="value">{{ value }}</div>
        </div>
        <slot v-else/>
    </div>
</template>

<script>
export default {
    name: "PlainArgument",
    props: {
        value: [String, Object]
    },
    computed: {
        showValue() {
            return !!this.value;
        }
    }
}
</script>

<style scoped>
.value {
    white-space: pre-wrap;
    overflow-wrap: break-word;
}
</style>
